document.addEventListener('DOMContentLoaded', function () {

  const webAppUrl = 'https://script.google.com/macros/s/AKfycbzqgQTr2SAcz9r5w0FX8udu0ZyJQdBqKKLRYRQ0dDolXxeHGf7h3MeZZlaTnO-gNxGI9g/exec';

  function updatePreorderBadge() {
    const badge = document.getElementById('preorder-count');
    const cart = JSON.parse(localStorage.getItem('preorderCart')) || [];

    if (badge) {
      const totalQuantity = cart.reduce((acc, item) => acc + item.quantity, 0);
      badge.innerText = totalQuantity;
      badge.style.display = totalQuantity > 0 ? 'flex' : 'none';
    }
  }

  document.addEventListener('preorderCartUpdated', updatePreorderBadge);
  updatePreorderBadge();

  function getCustomerEmail() {
    if (window.preorderCustomer && window.preorderCustomer.email) {
      return window.preorderCustomer.email;
    }

    if (typeof Shopify !== 'undefined' && Shopify.customer && Shopify.customer.email) {
      return Shopify.customer.email;
    }

    if (window.Shopify && window.Shopify.customer && window.Shopify.customer.email) {
      return window.Shopify.customer.email;
    }

    return 'guest';
  }

  function isLoggedIn() {
    return !!(window.preorderCustomer && window.preorderCustomer.loggedIn);
  }

  function showLoginMessage() {
    const goToLogin = confirm('Please log in to add pre-order items. Click OK to go to the login page.');
    if (goToLogin) {
      if (window.preorderCustomer && window.preorderCustomer.loginUrl) {
        window.location.href = window.preorderCustomer.loginUrl;
      } else {
        window.location.href = '/account/login';
      }
    }
  }

  function isPreorderProduct(productElement) {
    const tags = productElement.dataset.productTags || '';
    return tags.split(',').map(t => t.trim().toLowerCase()).includes('preorder');
  }

  function addPreorderButtons() {
    document.querySelectorAll('product-card').forEach(card => {
      if (!isPreorderProduct(card)) return;

      if (!card.querySelector('.add-to-preorder-btn')) {
        const btn = document.createElement('button');
        btn.className = 'add-to-preorder-btn';
        btn.dataset.id = card.dataset.productId || '';
        btn.dataset.title = card.querySelector('.product-card__link span')?.innerText || 'Product';
        btn.dataset.quantity = 1;
        btn.innerText = 'Add to Pre-Order';

        btn.style.marginTop = '10px';
        btn.style.padding = '6px 12px';
        btn.style.cursor = 'pointer';
        btn.style.backgroundColor = '#ff9800';
        btn.style.color = '#fff';
        btn.style.border = 'none';
        btn.style.borderRadius = '4px';

        const contentDiv = card.querySelector('.product-card__content');
        if (contentDiv) {
          contentDiv.appendChild(btn);
        }
      }
    });
  }

  addPreorderButtons();

  const observer = new MutationObserver(function () {
    addPreorderButtons();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener('click', function (e) {
    const button = e.target.closest('.add-to-preorder-btn');
    if (!button) return;

    e.preventDefault();

    // NEW: block guest users
    if (!isLoggedIn()) {
      showLoginMessage();
      return;
    }

    const product = {
      id: button.dataset.id,
      title: button.dataset.title,
      quantity: Number(button.dataset.quantity) || 1,
      user_email: getCustomerEmail()
    };

    let cart = JSON.parse(localStorage.getItem('preorderCart')) || [];
    const index = cart.findIndex(item => item.id === product.id);

    if (index > -1) {
      cart[index].quantity += product.quantity;
    } else {
      cart.push(product);
    }

    localStorage.setItem('preorderCart', JSON.stringify(cart));

    document.dispatchEvent(new CustomEvent('preorderCartUpdated'));

    fetch(webAppUrl, {
      method: 'POST',
      body: JSON.stringify({
        items: [product],
        timestamp: new Date().toISOString()
      })
    })
      .then(res => res.json())
      .then(data => console.log('Sent to Sheet', data))
      .catch(err => console.error('Error sending to Sheet', err));

    alert(`${product.title} added to Pre-Order`);
  });

});